console.log('Audio-Recommendations Script geladen');

// === SIDEBAR EMPFEHLUNGEN FUNKTIONALITÄT ===

// Empfehlungen anzeigen wenn Demo geladen
function showRecommendations() {
  console.log('=== showRecommendations() aufgerufen ===');
  
  const sidebar = document.getElementById('recommendations-sidebar');
  const recCount = document.getElementById('rec-count');
  
  if (window.similarTracks && window.similarTracks.length > 0) {
    // Aktueller Interpret (vom ersten Track oder aktuellen Produkt)
    const currentVendor = '{{ product.vendor }}'; // Liquid-Variable
    
    // Nach gleichem Interpreten filtern
    const vendorTracks = window.similarTracks.filter(track => 
      track.vendor === currentVendor
    );
    
    // Falls Vendor-Tracks gefunden, verwende diese, sonst alle
    if (vendorTracks.length > 0) {
      window.similarTracks = vendorTracks.slice(0, 5);
      console.log('Gefiltert nach Interpret:', currentVendor, '- Anzahl:', window.similarTracks.length);
    }
    
    buildSidebarRecommendationsList();
    recCount.textContent = `(${window.similarTracks.length})`;
    sidebar.style.display = 'block';
    
    // Mobile Toggle Button anzeigen
    const mobileToggle = document.querySelector('.mobile-recommendations-toggle');
    if (mobileToggle) {
      mobileToggle.style.display = 'block';
      mobileToggle.innerHTML = `🎵 Empfehlungen anzeigen (${window.similarTracks.length})`;
    }
    
    console.log('Sidebar Empfehlungen angezeigt:', window.similarTracks.length);
  }
}

// Empfehlungen verstecken wenn kein Demo
function hideRecommendations() {
  const sidebar = document.getElementById('recommendations-sidebar');
  const mobileToggle = document.querySelector('.mobile-recommendations-toggle');
  const overlay = document.querySelector('.sidebar-overlay');
  
  if (sidebar) {
    sidebar.style.display = 'none';
    sidebar.classList.remove('mobile-open');
  }
  
  if (mobileToggle) {
    mobileToggle.style.display = 'none';
  }
  
  if (overlay) {
    overlay.classList.remove('active');
  }
  
  console.log('Sidebar Empfehlungen versteckt');
}

// Sidebar Empfehlungsliste aufbauen
function buildSidebarRecommendationsList() {
  const recList = document.getElementById('recommendations-list');
  
  if (!window.similarTracks || window.similarTracks.length === 0) return;
  
  recList.innerHTML = window.similarTracks.map(track => `
    <div class="recommendation-item">
    <a href="/products/${track.handle}" class="rec-title-link">
      <span class="rec-title">${track.title}</span></a>
      <span class="rec-vendor">${track.vendor}</span>
      <div class="rec-bottom">
        <span class="rec-price">${track.price}</span>
        <button class="rec-demo-btn audio-load-btn" 
                data-sku="${track.sku}" 
                data-vendor="${track.vendor}" 
                data-product="${track.title}" 
                data-type="${track.type}">
          🎵 Demo
        </button>
      </div>
    </div>
  `).join('');
  
  // Event-Listener für neue Demo-Buttons hinzufügen
  attachRecommendationListeners();
}

// Event-Listener für Empfehlungs-Buttons
function attachRecommendationListeners() {
  const recButtons = document.querySelectorAll('.recommendation-item .audio-load-btn');
  
  recButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.stopPropagation();
      
      const sku = this.dataset.sku;
      const vendor = this.dataset.vendor;
      const product = this.dataset.product;
      const productType = this.dataset.type;
      
      console.log('Empfohlenes Demo laden:', product, 'von', vendor);
      
      // Nutzt die gleiche Logik wie deine bestehende audio-button.js
      loadRecommendedDemo(sku, vendor, product, productType);
      
      // Auf Mobile: Sidebar nach Demo-Load schließen
      if (window.innerWidth <= 768) {
        setTimeout(() => {
          toggleRecommendationsSidebar();
        }, 500);
      }
    });
  });
}

// Demo aus Empfehlungen laden (kopiert deine bestehende Logik)
function loadRecommendedDemo(sku, vendor, product, productType) {
  const playerContainer = document.querySelector('.player-container');
  
  if (playerContainer) {
    // Bestehende iframes entfernen
    const existingIframes = playerContainer.querySelectorAll('iframe');
    existingIframes.forEach(function(iframe) {
      iframe.remove();
    });
    
    // Audio URL erstellen (gleiche Logik wie in audio-button.js)
    let audioUrl = 'https://geerdes.media/apps/demos/?a=' + sku;
    let height = '100px';
    
    if (productType === 'Midifile' || productType === 'Pro-Midifile' || productType === 'ProV-Midifile') {
      audioUrl += '&o=0';
    } else if (productType === 'Playback') {
      audioUrl += '&o=1';
    } else if (productType === 'Pro-Playback') {
      audioUrl += '&o=2';
    } else if (productType === 'ProV-Playback') {
      audioUrl += '&o=3';
      height = '150px';
    } else {
      audioUrl += '&o=0';
    }
    
    audioUrl += '&iframe&download&color=424548,424548';
    
    // Neues iframe erstellen
    const newIframe = document.createElement('iframe');
    newIframe.src = audioUrl;
    newIframe.style.border = '0';
    newIframe.style.overflowY = 'hidden';
    newIframe.style.width = '100%';
    newIframe.style.height = height;
    newIframe.scrolling = 'no';
    
    playerContainer.appendChild(newIframe);
    
    // Track-Info aktualisieren (gleiche Logik wie in audio-button.js)
    const trackInfo = document.querySelector('.track-info');
    if (trackInfo) {
      const trackTitleSpans = trackInfo.querySelectorAll('span');
      
      if (trackTitleSpans.length > 1) {
        trackTitleSpans[1].textContent = product;
      }
      
      if (trackTitleSpans.length > 3) {
        trackTitleSpans[3].textContent = vendor;
      }
    }
    
    // Fixed Player Status aktualisieren// Fixed Player Status aktualisieren UND Buy-Button anzeigen
setTimeout(() => {
  const fixedPlayerTrackTitle = document.querySelector('.fixed-audio-player .track-title');
  if (fixedPlayerTrackTitle) {
    // Schritt 1: "Demo geladen" anzeigen
    fixedPlayerTrackTitle.innerHTML = '✅ Demo geladen';
    console.log('Fixed Player Status gesetzt: Demo geladen');

    // Schritt 2: Nach 2 Sekunden Button AN GLEICHER STELLE anzeigen
    setTimeout(function() {
      const isProductPage = window.location.pathname.includes('/products/');
      
      if (!isProductPage) {
        // Handle aus window.similarTracks finden
        let productHandle = null;
        if (window.similarTracks) {
          const matchingTrack = window.similarTracks.find(function(track) {
            return track.sku === sku;
          });
          if (matchingTrack && matchingTrack.handle) {
            productHandle = matchingTrack.handle;
          }
        }
        
        // Fallback: Handle aus Titel erstellen
        if (!productHandle) {
          productHandle = createHandleFromTitle(product);
        }
        
        console.log('Ersetze "Demo geladen" durch Kaufen-Button für:', product, 'Handle:', productHandle);
        
        if (productHandle) {
          // Button DIREKT in track-title einfügen (ersetzt "Demo geladen")
          currentDemoProduct = {
            handle: productHandle,
            title: product
          };
          
          fixedPlayerTrackTitle.innerHTML = '<button class="inline-buy-btn" onclick="goToProductPage()" style="background: linear-gradient(135deg, #d4af37, #b8941f); color: white; border: none; padding: 4px 8px; border-radius: 4px; font-size: 11px; font-weight: bold; cursor: pointer; transition: all 0.3s ease;">Jetzt bestellen</button>';
          
          console.log('Inline Kaufen-Button angezeigt für:', product);
        }
      }
    }, 2000); // 2 Sekunden warten
  }
}, 500);

    
    console.log('Empfohlenes Audio geladen:', product, 'von', vendor);
  }
}

// Mobile Sidebar Toggle
function toggleRecommendationsSidebar() {
  const sidebar = document.getElementById('recommendations-sidebar');
  const overlay = document.querySelector('.sidebar-overlay');
  
  if (window.innerWidth <= 768) {
    // Mobile: Sidebar als Overlay
    sidebar.classList.toggle('mobile-open');
    
    if (!overlay) {
      const newOverlay = document.createElement('div');
      newOverlay.className = 'sidebar-overlay';
      newOverlay.onclick = toggleRecommendationsSidebar;
      document.body.appendChild(newOverlay);
    }
    
    document.querySelector('.sidebar-overlay').classList.toggle('active');
    
    // Body Scroll verhindern wenn Sidebar offen
    if (sidebar.classList.contains('mobile-open')) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  } else {
    // Desktop: Sidebar ein/ausblenden
    if (sidebar.style.display === 'none') {
      sidebar.style.display = 'block';
    } else {
      sidebar.style.display = 'none';
    }
  }
}

// Mobile Toggle Button hinzufügen
function addMobileToggleButton() {
  const playerArea = document.querySelector('.main-player-area');
  
  if (playerArea && !document.querySelector('.mobile-recommendations-toggle')) {
    const toggleBtn = document.createElement('button');
    toggleBtn.className = 'mobile-recommendations-toggle';
    toggleBtn.innerHTML = '🎵 Empfehlungen anzeigen';
    toggleBtn.onclick = toggleRecommendationsSidebar;
    toggleBtn.style.display = 'none';
    
    playerArea.appendChild(toggleBtn);
  }
}

// Window Resize Handler
function handleWindowResize() {
  const sidebar = document.getElementById('recommendations-sidebar');
  const overlay = document.querySelector('.sidebar-overlay');
  
  if (window.innerWidth > 768) {
    // Desktop: Mobile-Klassen entfernen
    if (sidebar) {
      sidebar.classList.remove('mobile-open');
    }
    if (overlay) {
      overlay.classList.remove('active');
    }
    document.body.style.overflow = '';
  }
}

// Observer für Demo-Load Events (überwacht deine bestehende audio-button.js)
document.addEventListener('DOMContentLoaded', function() {
  // Mobile Toggle Button hinzufügen
  addMobileToggleButton();
  
  // Window Resize Listener
  window.addEventListener('resize', handleWindowResize);
  
  // Überwacht Änderungen im Player-Container
  const playerContainer = document.querySelector('.player-container');
  
  if (playerContainer) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          // Wenn iframe hinzugefügt wird = Demo geladen
          const addedIframes = Array.from(mutation.addedNodes).filter(node => 
            node.tagName === 'IFRAME'
          );
          
          if (addedIframes.length > 0) {
            setTimeout(() => {
              showRecommendations();
            }, 1000);
          }
          
          // Wenn iframe entfernt wird = Demo geschlossen
          const removedIframes = Array.from(mutation.removedNodes).filter(node => 
            node.tagName === 'IFRAME'
          );
          
          if (removedIframes.length > 0 && playerContainer.querySelectorAll('iframe').length === 0) {
            hideRecommendations();
          }
        }
      });
    });
    
    observer.observe(playerContainer, { childList: true });
  }
  
  // Keyboard Navigation Support
  document.addEventListener('keydown', function(e) {
    const sidebar = document.getElementById('recommendations-sidebar');
    
    // ESC-Taste schließt Mobile Sidebar
    if (e.key === 'Escape' && sidebar && sidebar.classList.contains('mobile-open')) {
      toggleRecommendationsSidebar();
    }
  });
});

// Legacy-Funktion für Rückwärtskompatibilität
function toggleRecommendations() {
  console.log('Legacy toggleRecommendations() aufgerufen - verwende toggleRecommendationsSidebar()');
  toggleRecommendationsSidebar();
}
// Sidebar manuell schließen
function closeSidebar() {
  const sidebar = document.getElementById('recommendations-sidebar');
  const mobileToggle = document.querySelector('.mobile-recommendations-toggle');
  
  if (sidebar) {
    sidebar.style.display = 'none';
  }
  
  if (mobileToggle) {
    mobileToggle.style.display = 'block';
    mobileToggle.innerHTML = '🎵 Empfehlungen anzeigen';
  }
  
  console.log('Sidebar manuell geschlossen');
}
